import { AugmentationPanelLegacyForm } from "@pathwright/ux/src/components/augmentation/AugmentationPanelLegacyForm"
import { resolveToFromLinkProps } from "@pathwright/ux/src/components/link/Link"
import { useHistory, useParams, useRouteMatch } from "react-router-dom"
import AssignFlow from "./AssignFlow"

function AssignAugmentation() {
  const { userId, communityGroupId, resourceId, role } = useParams<{
    userId?: string
    communityGroupId?: string
    resourceId?: string
    role?: any
  }>()
  const history = useHistory()
  const { url } = useRouteMatch()

  return (
    <AugmentationPanelLegacyForm
      css={{
        "& .AssignPicker": {
          bg: "transparent",
          borderTop: "1px solid rgba(0,0,0,0.2)",
          borderBottom: "1px solid rgba(0,0,0,0.2)"
        }
      }}
    >
      <AssignFlow
        // @ts-expect-error: AssignFlow does expect userId, communityGroupId, resourceId, role
        userId={userId ? parseInt(userId) : null}
        communityGroupId={communityGroupId ? parseInt(communityGroupId) : null}
        resourceId={resourceId ? parseInt(resourceId) : null}
        role={role}
        onClose={() => {
          console.log("onClose")
          history.push(resolveToFromLinkProps({ relativeTo: "../" }, url)!)
        }}
      />
    </AugmentationPanelLegacyForm>
  )
}

export default AssignAugmentation
